export const Loading = () => {
  return <h6>Authentication in progress...</h6>;
};
